$ember-50: rgb(34, 39, 43);
$ember-100: rgb(28, 42, 59);
$ember-150: rgb(28, 42, 76);
$ember-200: rgb(37, 38, 92);
$ember-250: rgb(51, 31, 104);
$ember-300: rgb(68, 17, 112);
$ember-350: rgb(97, 17, 117);
$ember-400: rgb(128, 15, 115);
$ember-450: rgb(159, 9, 106);
$ember-500: rgb(188, 7, 88);
$ember-550: rgb(215, 21, 58);
$ember-600: rgb(222, 43, 52);
$ember-650: rgb(228, 59, 46);
$ember-700: rgb(233, 73, 39);
$ember-750: rgb(238, 86, 33);
$ember-800: rgb(243, 99, 27);
$ember-850: rgb(247, 115, 0);
$ember-900: rgb(249, 130, 0);
$ember-950: rgb(251, 145, 0);
$ember-1000: rgb(251, 160, 0);
$ember-1050: rgb(250, 175, 5);
$earthfire-50: rgb(82, 55, 25);
$earthfire-100: rgb(95, 54, 13);
$earthfire-150: rgb(108, 51, 0);
$earthfire-200: rgb(122, 46, 0);
$earthfire-250: rgb(135, 38, 0);
$earthfire-300: rgb(148, 27, 0);
$earthfire-350: rgb(167, 42, 5);
$earthfire-400: rgb(185, 56, 11);
$earthfire-450: rgb(204, 70, 17);
$earthfire-500: rgb(224, 85, 22);
$earthfire-550: rgb(243, 99, 27);
$earthfire-600: rgb(247, 115, 0);
$earthfire-650: rgb(249, 130, 0);
$earthfire-700: rgb(251, 145, 0);
$earthfire-750: rgb(251, 160, 0);
$earthfire-800: rgb(250, 175, 5);
$earthfire-850: rgb(250, 187, 59);
$earthfire-900: rgb(250, 199, 87);
$earthfire-950: rgb(251, 210, 111);
$earthfire-1000: rgb(252, 221, 133);
$earthfire-1050: rgb(253, 231, 154);
$fuchsia-heat-50: rgb(101, 0, 77);
$fuchsia-heat-100: rgb(123, 2, 95);
$fuchsia-heat-150: rgb(146, 4, 114);
$fuchsia-heat-200: rgb(169, 8, 133);
$fuchsia-heat-250: rgb(193, 13, 153);
$fuchsia-heat-300: rgb(217, 18, 174);
$fuchsia-heat-350: rgb(230, 30, 146);
$fuchsia-heat-400: rgb(240, 45, 119);
$fuchsia-heat-450: rgb(245, 62, 91);
$fuchsia-heat-500: rgb(246, 80, 62);
$fuchsia-heat-550: rgb(243, 99, 27);
$fuchsia-heat-600: rgb(247, 115, 0);
$fuchsia-heat-650: rgb(249, 130, 0);
$fuchsia-heat-700: rgb(251, 145, 0);
$fuchsia-heat-750: rgb(251, 160, 0);
$fuchsia-heat-800: rgb(250, 175, 5);
$fuchsia-heat-850: rgb(250, 187, 59);
$fuchsia-heat-900: rgb(250, 199, 87);
$fuchsia-heat-950: rgb(251, 210, 111);
$fuchsia-heat-1000: rgb(252, 221, 133);
$fuchsia-heat-1050: rgb(253, 231, 154);
$polar-glow-50: rgb(0, 38, 100);
$polar-glow-100: rgb(1, 51, 128);
$polar-glow-150: rgb(3, 65, 158);
$polar-glow-200: rgb(7, 79, 189);
$polar-glow-250: rgb(13, 93, 220);
$polar-glow-300: rgb(20, 108, 253);
$polar-glow-350: rgb(0, 119, 231);
$polar-glow-400: rgb(0, 126, 208);
$polar-glow-450: rgb(0, 130, 184);
$polar-glow-500: rgb(0, 130, 162);
$polar-glow-550: rgb(46, 128, 142);
$polar-glow-600: rgb(66, 146, 159);
$polar-glow-650: rgb(84, 163, 176);
$polar-glow-700: rgb(103, 182, 193);
$polar-glow-750: rgb(121, 200, 211);
$polar-glow-800: rgb(140, 219, 229);
$polar-glow-850: rgb(154, 223, 229);
$polar-glow-900: rgb(169, 227, 229);
$polar-glow-950: rgb(182, 231, 230);
$polar-glow-1000: rgb(196, 235, 231);
$polar-glow-1050: rgb(209, 238, 234);
$glacier-pool-50: rgb(68, 17, 112);
$glacier-pool-100: rgb(81, 30, 136);
$glacier-pool-150: rgb(93, 43, 161);
$glacier-pool-200: rgb(106, 57, 187);
$glacier-pool-250: rgb(117, 70, 214);
$glacier-pool-300: rgb(128, 85, 241);
$glacier-pool-350: rgb(115, 89, 246);
$glacier-pool-400: rgb(100, 94, 250);
$glacier-pool-450: rgb(83, 98, 252);
$glacier-pool-500: rgb(60, 103, 253);
$glacier-pool-550: rgb(20, 108, 253);
$glacier-pool-600: rgb(0, 137, 255);
$glacier-pool-650: rgb(12, 162, 255);
$glacier-pool-700: rgb(59, 185, 255);
$glacier-pool-750: rgb(100, 205, 255);
$glacier-pool-800: rgb(140, 224, 255);
$glacier-pool-850: rgb(154, 227, 255);
$glacier-pool-900: rgb(167, 229, 255);
$glacier-pool-950: rgb(179, 232, 254);
$glacier-pool-1000: rgb(191, 234, 254);
$glacier-pool-1050: rgb(203, 237, 253);
$deep-current-50: rgb(11, 63, 71);
$deep-current-100: rgb(18, 75, 84);
$deep-current-150: rgb(25, 88, 98);
$deep-current-200: rgb(32, 101, 113);
$deep-current-250: rgb(39, 114, 127);
$deep-current-300: rgb(46, 128, 142);
$deep-current-350: rgb(0, 130, 162);
$deep-current-400: rgb(0, 130, 184);
$deep-current-450: rgb(0, 126, 208);
$deep-current-500: rgb(0, 119, 231);
$deep-current-550: rgb(20, 108, 253);
$deep-current-600: rgb(0, 137, 255);
$deep-current-650: rgb(12, 162, 255);
$deep-current-700: rgb(59, 185, 255);
$deep-current-750: rgb(100, 205, 255);
$deep-current-800: rgb(140, 224, 255);
$deep-current-850: rgb(154, 227, 255);
$deep-current-900: rgb(167, 229, 255);
$deep-current-950: rgb(179, 232, 254);
$deep-current-1000: rgb(191, 234, 254);
$deep-current-1050: rgb(203, 237, 253);
$blue-red-50: rgb(0, 38, 100);
$blue-red-100: rgb(1, 51, 128);
$blue-red-150: rgb(3, 65, 158);
$blue-red-200: rgb(7, 79, 189);
$blue-red-250: rgb(13, 93, 220);
$blue-red-300: rgb(20, 108, 253);
$blue-red-350: rgb(76, 142, 255);
$blue-red-400: rgb(121, 172, 255);
$blue-red-450: rgb(165, 200, 255);
$blue-red-500: rgb(210, 228, 255);
$blue-red-550: rgb(254, 215, 214);
$blue-red-600: rgb(249, 175, 174);
$blue-red-650: rgb(241, 134, 135);
$blue-red-700: rgb(229, 89, 97);
$blue-red-750: rgb(215, 21, 58);
$blue-red-800: rgb(191, 15, 52);
$blue-red-850: rgb(167, 10, 45);
$blue-red-900: rgb(143, 5, 39);
$blue-red-950: rgb(121, 2, 32);
$blue-red-1000: rgb(99, 0, 25);
$blue-orange-50: rgb(0, 38, 100);
$blue-orange-100: rgb(1, 51, 128);
$blue-orange-150: rgb(3, 65, 158);
$blue-orange-200: rgb(7, 79, 189);
$blue-orange-250: rgb(13, 93, 220);
$blue-orange-300: rgb(20, 108, 253);
$blue-orange-350: rgb(76, 142, 255);
$blue-orange-400: rgb(121, 172, 255);
$blue-orange-450: rgb(165, 200, 255);
$blue-orange-500: rgb(210, 228, 255);
$blue-orange-550: rgb(255, 226, 214);
$blue-orange-600: rgb(255, 196, 173);
$blue-orange-650: rgb(254, 166, 131);
$blue-orange-700: rgb(250, 134, 87);
$blue-orange-750: rgb(243, 99, 27);
$blue-orange-800: rgb(224, 85, 22);
$blue-orange-850: rgb(204, 70, 17);
$blue-orange-900: rgb(185, 56, 11);
$blue-orange-950: rgb(167, 42, 5);
$blue-orange-1000: rgb(148, 27, 0);
$purple-yellow-50: rgb(68, 17, 112);
$purple-yellow-100: rgb(81, 30, 136);
$purple-yellow-150: rgb(93, 43, 161);
$purple-yellow-200: rgb(106, 57, 187);
$purple-yellow-250: rgb(117, 70, 214);
$purple-yellow-300: rgb(128, 85, 241);
$purple-yellow-350: rgb(150, 123, 247);
$purple-yellow-400: rgb(174, 158, 251);
$purple-yellow-450: rgb(199, 191, 254);
$purple-yellow-500: rgb(227, 223, 255);
$purple-yellow-550: rgb(255, 240, 218);
$purple-yellow-600: rgb(255, 224, 180);
$purple-yellow-650: rgb(254, 208, 139);
$purple-yellow-700: rgb(252, 192, 93);
$purple-yellow-750: rgb(250, 175, 5);
$purple-yellow-800: rgb(219, 153, 3);
$purple-yellow-850: rgb(189, 132, 2);
$purple-yellow-900: rgb(160, 111, 1);
$purple-yellow-950: rgb(132, 91, 0);
$purple-yellow-1000: rgb(105, 72, 0);
$fuchsia-teal-50: rgb(101, 0, 77);
$fuchsia-teal-100: rgb(123, 2, 95);
$fuchsia-teal-150: rgb(146, 4, 114);
$fuchsia-teal-200: rgb(169, 8, 133);
$fuchsia-teal-250: rgb(193, 13, 153);
$fuchsia-teal-300: rgb(217, 18, 174);
$fuchsia-teal-350: rgb(230, 91, 191);
$fuchsia-teal-400: rgb(240, 136, 207);
$fuchsia-teal-450: rgb(248, 177, 223);
$fuchsia-teal-500: rgb(253, 216, 239);
$fuchsia-teal-550: rgb(214, 229, 232);
$fuchsia-teal-600: rgb(174, 203, 209);
$fuchsia-teal-650: rgb(134, 178, 186);
$fuchsia-teal-700: rgb(93, 153, 164);
$fuchsia-teal-750: rgb(46, 128, 142);
$fuchsia-teal-800: rgb(39, 114, 127);
$fuchsia-teal-850: rgb(32, 101, 113);
$fuchsia-teal-900: rgb(25, 88, 98);
$fuchsia-teal-950: rgb(18, 75, 84);
$fuchsia-teal-1000: rgb(11, 63, 71);
